import React from 'react';

export const Footer = () => {
  return (
    <footer className="page-footer" id="footer">
      <div className="footer-container">
        <div className="page-footer-design">
          {/* df - design footer */}
          <div className="design1 df"></div>
          <div className="design2 df"></div>
          <div className="design3 df"></div>
        </div>
        <div className="page-footer-content">
          <div className="social-meadia-text">
            <p>Соц. Мережі:</p>
          </div>
          <div className="page-footer-center">
            <div className="social-media-links">
              <div className="footer-link inst-footer-link">
                {/* <a href="https://www.instagram.com/krasilovskyi/"> */}
                  <i className="fab fa-instagram"></i>
                {/* </a> */}
              </div>
              <div className="footer-link">
                {/* <a href="https://www.facebook.com/krasilovskyi"> */}
                  <i className="fab fa-facebook-square"></i>
                {/* </a> */}
              </div>
            </div>
            <div className="copyright">© 2021 All Rights Reserved</div>
          </div>
          <div className="phone">
            <p>Телефон:</p>
            <p className="phone-number">0000000000</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
